import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';
import { IEmployee } from '../../models';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_EMPLOYEE_SP_LIST_ID');

const expand = '&expand=fields(select=title,eEmployeeId, eDepartment, eDepartmentCode, eMail, eBizTitle, eBizTitleCode,eLocation,eDefault,ePhone,eAddress)';

export class EmployeeService {
  static async getEmployees(department?: string): Promise<IEmployee[]> {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=5000`))
      .then(res => res.data.value && res.data.value.map((o: any) => ({ id: o.id, ...o.fields })))
      .catch(err => { throw new RequestError(err) });
  }

  static async getEmployeesWithId() {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async addEmployee(fields: any) {
    return api.post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), fields)
      .then(res => res)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateEmployee(id: any, fields: any) {
    return api.patch(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`), fields)
      .then(res => res)
      .catch(err => { throw new RequestError(err) });
  }

  static async deleteEmployee(id: any, listId?: string) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }
}
